// ** Start Highlight Script ** //
class HighlightCta {
    /* Highlight CTA Module */
    /* A basic module to simplify element highlighting */
    init(obj, func = null) {
        if(!obj) { return err("No Object Defined."); }
        if(!obj.id) { return err("No ID Defined. Example: { id: 'highlightcta' }"); }

        let cta = document.getElementById(obj.id);
        document.querySelectorAll('[href="#' + obj.id + '"]').forEach(elem => {
            elem.addEventListener('click', () => {
                if(obj.outline) { cta.style.outline = obj.outline; }

                if(func) { func() };
            });
        });

        return true;
    }

    err(err) {
        console.error("Error in Highlight CTA");
        console.error(err);

        return false;
    }
}

export default HighlightCta;